<template>
  <div id="app" @click="hideFilter">
    <router-view />
    <Feedback />
    <div class="ad-footer" v-if="adShow && adConfig && (adConfig.ios.show || adConfig.android.show)">
      <span class="close" @click="closeAd">关闭</span>
      <a v-if="isAndroid && adConfig.android.show" :href="adConfig.android.url" target="_blank">
        <img :src="adConfig.android.image" alt="">
      </a>
      <a v-if="isIOS && adConfig.ios.show" :href="adConfig.ios.url" target="_blank">
        <img :src="adConfig.ios.image" alt="">
      </a>
    </div>
    <pay-dialog v-if="payDialogShow" />
    <!-- <login-dialog v-if="loginDialogShow" /> -->
    <login-dialog-x v-if="loginDialogShow" />
    <remote-js 
      v-for="item in scriptAds" 
      :key="item.id" 
      :id="item.id" 
      :data="item.data" 
      :src="item.url" 
    />
    <footer-component />
  </div>
</template>

<script>
import PayDialog from '@/components/Pay.vue'
import LoginDialog from '@/components/Login.vue'
import LoginDialogX from '@/components/LoginX.vue'
import Feedback from '@/components/Feedback.vue'
import FooterComponent from '@/components/Footer'
import copyToClipboard from '@/utils/clipboard'
import { isWeixin, isMobile, isIOS, isAndroid } from '@/utils/navigator'
import { getCopyContent, getBlockedHistory, getFooterAdsInfo, getScriptAdsInfo } from '@/api/search'
export default {
  data () {
    return {
      url: '',
      adShow: true,
      content: '',
      isIOS: false,
      isCopy: false,
      isWeixin: false,
      isMobile: false,
      isAndroid: false,
      isHistory: false,
      adConfig: null,
      scriptAds: [],
    }
  },
  components: {
    Feedback,
    PayDialog,
    LoginDialog,
    LoginDialogX,
    FooterComponent
  },
  async mounted () {
    await this.updateUserinfo()

    this.isWeixin = isWeixin()
    this.isMobile = isMobile()
    this.isIOS = isIOS()
    this.isAndroid = isAndroid()

    const res = await getCopyContent()
    if (res && res.isCopy) {
      this.isCopy = res.isCopy
      this.content = res.content
    }

    const history = await getBlockedHistory()
    if (history && history.flag) {
      this.isHistory = history.flag

      if (this.isWeixin) {
        this.url = history.weixin
      } else {
        if (this.isMobile) {
          this.url = history.mobile
        }
      }

      if (this.url && window.history && window.history.pushState) {
        console.log('init state')
        window.history.pushState({
          redirect: true
        }, null, '#')
        window.addEventListener("popstate", this.onBrowserBack, false)
      }
    }

    this.adConfig = await getFooterAdsInfo()

    this.scriptAds = await getScriptAdsInfo() || []
  },
  methods: {
    hideFilter () {
      this.$store.commit('hideFilter')
      if (this.isCopy && this.isMobile){
        copyToClipboard(this.content)
      }
    },
    onBrowserBack (event) {
      if (event.state && event.state.redirect) {
        this.jumpTo(this.url)
      } else {
         window.history.replaceState({
          redirect: true
        }, null, '#')
      }
    },
    jumpTo(url) {
      const a = document.createElement('a')
      a.href = url
      a.click()
    },
    closeAd () {
      this.adShow = false
    }
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/_base.scss";
#app {
  height: 100%;
}
.ad-footer {
  position: fixed;
  z-index: 1000;
  display: none;
  bottom: 0;
  font-size: 0;
  word-spacing: 0;
  border-top: 1px solid #eee;
  .close {
    position: absolute;
    background-color: #fff;
    font-size: 12px;
    color: #333;
    padding: 2px 4px;
    top: 0;
    right: 0;
  }
  img {
    width: 100%;
  }
}
@media (max-width: 700px) {
  .ad-footer {
    display: flex;
  }
}
</style>

